import { useTranslation } from 'react-i18next';
import Divider from '@mui/material/Divider';
import { Typography } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const UC_UI: any;

const handleShowCookies = (): void => {
  UC_UI.showSecondLayer();
};

function FooterDivider() {
  return <Divider sx={{ height: 16, bgcolor: 'white', ml: 1, mr: 1 }} orientation="vertical" />;
}

export function LegalFooter() {
  const { t } = useTranslation('footer');

  return (
    <footer
      className={
        'bg-navigation-80 flex flex-row items-center w-full h-[64px] s:h-[32px] z-100 py-[2px]'
      }
    >
      <div className="s:pl-[40px] m:pl-[80px] pl-[0px] s:pr-[40px] m:pr-[80px] pr-[0px] flex flex-col s:flex-row items-center  justify-between w-full">
        <div className="flex flex-col s:flex-row justify-between">
          <div className="flex flex-row flex-wrap justify-center items-center h-[24px] text-[10px] font-normal leading-4 tracking-tight">
            <Typography
              component="a"
              variant="bodySMRegularLink"
              href="https://www.lkh.de/impressum"
              rel="noopener noreferrer"
              className="text-white-100"
              target="_blank"
            >
              {t('imprint')}
            </Typography>
            <FooterDivider />
            <Typography
              component="a"
              variant="bodySMRegularLink"
              href="https://www.lkh.de/datenschutz#cc"
              className="text-white-100"
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('privacy')}
            </Typography>
            <FooterDivider />
            <Typography
              component="a"
              variant="bodySMRegularLink"
              href="#"
              onClick={handleShowCookies}
              className="text-white-100"
            >
              {t('cookies')}
            </Typography>
            <FooterDivider />
            <Typography
              component="a"
              variant="bodySMRegularLink"
              href="https://lkh.de/anleitung"
              className="text-white-100"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('accessibilityStatement')}
            </Typography>
            <FooterDivider />
            <Typography
              component="a"
              variant="bodySMRegularLink"
              href="https://www.lkh.de/Vertragswiderruf"
              className="text-white-100"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontWeight: 800,
                color: '#000000 !important', // Black text
                backgroundColor: '#E7DA15', // Yellow background
                padding: '1px 5px',
                borderRadius: '3px',
                textDecoration: 'underline', // Add underline
                '&:hover': {
                  backgroundColor: '#F0E648', // Slightly darker yellow on hover
                  color: '#000000',
                  textDecoration: 'none'
                }
              }}
            >
              {t('contractCancelation')}
            </Typography>
          </div>
        </div>
        <div>
          <p className=" p-0 text-[10px] font-normal leading-4 tracking-tight text-white-100">
            {t('name')}
          </p>
        </div>
      </div>
    </footer>
  );
}
